import Dropdown from "react-bootstrap/Dropdown";

export default function DateDropdown({ dateRange, handleDateRangeChange }) {
  return (
    <Dropdown className='date-dropdown p-2'>
      <Dropdown.Toggle
        variant='outline-secondary'
        style={{
          minWidth: "220px",
          backgroundColor: "#fff",
          border: "1px solid #ced4da",
          color: "#212529",
          boxShadow: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "left",
        }}
        id='dateDropdown'
      >
        Past {dateRange} Days
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleDateRangeChange("7")}>
          Past 7 Days
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateRangeChange("14")}>
          Past 14 Days
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateRangeChange("30")}>
          Past 30 Days
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateRangeChange("60")}>
          Past 60 Days
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleDateRangeChange("90")}>
          Past 90 Days
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
